// The HRA informs the needs for the Care Plan.
export const CARE_PLAN_STATUS_ENUM = {
    PENDING_OPEN: 5, // HRA is complete, and a Care Plan needs to be created

    OPEN: 6, // A Care Plan has been started but is not ready to implement

    APPROVED: 3, // A Care Plan has been approved for patient treatment

    TRANSITION: 1, // An approved Care Plan needs to be updated for ongoing treatment. After TRANSITION, the Care Plan will moved to OPEN again, then back to APPROVED.
};
